


















import Vue from 'vue';

export default Vue.extend({
  props: {
    markedText: {
      type: String,
      default: null,
      required: false,
    },
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    image: {
      type: String,
      default: null,
      required: false,
    },
    link: {
      type: Object,
      required: true,
    },
  },
});
